import React from 'react';
import style from './style.scss';
import {Input, Textarea} from 'components/vitrade-forms/common';
import {SubCategorySelectorInput} from 'components/vitrade-forms';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import {Demands} from 'api';
import { ShowIf } from 'components/utils';
import Recaptcha from 'react-recaptcha';
import {connect} from 'react-redux';
import CONFIG from 'base/constants/config';

class FormPostDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categoryIds: [],
      content: this.props.contentDemandFromProduct || '',
      isSubmit: false,
      optionTypes: [
        {label: 'Yêu cầu báo giá', value: 'BAOGIA', id: 'typeQuotes'},
        {label: 'Yêu cầu tư vấn', value: 'TUVAN', id: 'typeAdvisory'}
      ],
      type: 'BAOGIA',
      optionDistricts: [
        {label: 'Tất cả', value: ''},
        {label: 'Huyện Ba Tơ', value: 'Huyện Ba Tơ'},
        {label: 'Huyện Bình Sơn', value: 'Huyện Bình Sơn'},
        {label: 'Huyện Đức Phổ', value: 'Huyện Đức Phổ'},
        {label: 'Huyện Lý Sơn', value: 'Huyện Lý Sơn'},
        {label: 'Huyện Minh Long', value: 'Huyện Minh Long'},
        {label: 'Huyện Mộ Đức', value: 'Huyện Mộ Đức'},
        {label: 'Huyện Nghĩa Hành', value: 'Huyện Nghĩa Hành'},
        {label: 'Huyện Sơn Hà', value: 'Huyện Sơn Hà'},
        {label: 'Huyện Sơn Tây', value: 'Huyện Sơn Tây'},
        {label: 'Huyện Sơn Tịnh', value: 'Huyện Sơn Tịnh'},
        {label: 'Huyện Tây Trà', value: 'Huyện Tây Trà'},
        {label: 'Huyện Trà Bồng', value: 'Huyện Trà Bồng'},
        {label: 'Huyện Tư Nghĩa', value: 'Huyện Tư Nghĩa'}
      ],
      district: '',
      phone: '',
      note: '',
      bannersRight: [
        {image: require('assets/images/demand/banner-right-01.png')},
        {image: require('assets/images/demand/banner-right-02.png')},
        {image: require('assets/images/demand/banner-right-03.png')}
      ]
    };
    this.props.validators['formDemand'] = [];
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.selectCategories = this.selectCategories.bind(this);
    this.getPhoneDefault = this.getPhoneDefault.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formDemand'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (this.state.categoryIds.length === 0) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn ít nhất một nhóm sản phẩm cho sản phẩm hiện tại');
      return false;
    }
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });
    this.setState({categoryIds});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {categoryIds, content, type, phone, district, note} = this.state;
      const data = {
        categoryIds,
        content,
        type,
        phone: type === 'TUVAN' ? phone : '',
        district,
        note
      };
      this.setState({isSubmit: true});
      Demands.actions.add.request({}, {data}).then(response => {
        this.setState({
          isSubmit: false,
          content: '',
          categoryIds: [],
          type: 'BAOGIA',
          phone: '',
          district: '',
          note: ''
        });
        toastr.success('Thành công!', 'Gửi nhu cầu thành công.');
      }).catch(error => {
        this.setState({isSubmit: false});
      });
    }
  }

  getPhoneDefault() {
    const phone = this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.phone || '';
    this.setState({phone});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.contentDemandFromProduct && nextProps.contentDemandFromProduct !== this.props.contentDemandFromProduct) {
      this.setState({content: this.props.contentDemandFromProduct});
    }
  }

  render() {
    const {isSubmit, content, optionTypes, type, phone, categoryIds, optionDistricts, district, note, bannersRight} = this.state;
    return (
      <div className="post-demand-container">
        <form className="form-post-demand" onSubmit={this.onSubmit} noValidate>
          <div className="section">
            <h3 className='section-heading'>Loại yêu cầu</h3>
            <div className='wrap-radio-type'>
              {
                optionTypes.map((option, i) => (
                  <div className='radio' key={i}>
                    <input
                      className='input-radio-type'
                      id={option.id}
                      type='radio'
                      onChange={this.onChange}
                      checked={type === option.value}
                      value={option.value}
                      name="type"
                    />
                    <label className='radio-label' htmlFor={option.id}>{option.label}</label>
                  </div>
                ))
              }
            </div>
          </div>
          <Textarea type="text" placeholder="Nhập nội dung..."
            className="wrap-product-des"
            inputClassName="product-des-input"
            iconFontSet="glyphicon"
            iconClassName="glyphicon-user"
            onChange={this.onChange}
            name="content"
            value={content}
            required={true}
            bindValidator={this} channel="formDemand"
            errorMessage="Bạn vui lòng nhập nội dung"
          />
          <ShowIf condition={type === 'TUVAN'}>
            <div className="phone-box section">
            <h3 className='section-heading'>Số điện thoại của bạn</h3>
              <div className="phone-input">
                <Input type="text" placeholder="Số điện thoại..."
                  name="phone"
                  value={phone}
                  required={type === 'TUVAN'}
                  onChange={this.onChange}
                  bindValidator={this} channel="formDemand"
                  errorMessage="Số điện thoại không được để trống"/>
              </div>
              <div className="phone-button">
                <button className="btn-medium" type="button" onClick={this.getPhoneDefault}>Sử dụng số đã đăng ký</button>
              </div>
            </div>
          </ShowIf>
          <div className="section district-dropdown">
            <h3 className="section-heading">Khu vực</h3>
            <div className="dropdown custom-select">
              <select name="district" onChange={this.onChange} value={district}>
                {
                  optionDistricts.map((option, i) => (
                    <option key={i} value={option.value}>{option.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <Textarea type="text" placeholder="Nhập ghi chú..."
            className="wrap-product-des"
            inputClassName="product-des-input"
            iconFontSet="glyphicon"
            iconClassName="glyphicon-user"
            onChange={this.onChange}
            name="note"
            value={note}
            required={false}
            bindValidator={this} channel="formDemand"
            errorMessage="Bạn vui lòng nhập ghi chú"
          />
          <SubCategorySelectorInput label="Chọn nhóm sản phẩm" onChange={this.selectCategories} data={categoryIds}/>
          <div className="google-captcha">
            <Recaptcha sitekey={CONFIG.CAPTCHA_KEY}/>
          </div>
          <div className="form-post-demand-btn-wrap">
            <LaddaButton className="post-demand-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi yêu cầu</LaddaButton>
          </div>
        </form>
      </div>
    );
  }
}

FormPostDemand.defaultProps = {
  validators: {}
};

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default connect(bindStateToProps)(FormPostDemand);


// WEBPACK FOOTER //
// ./components/users/sub-view/post-demand/FormPostDemand.jsx